export default __webpack_public_path__ + "static/media/race-finder-mobile.228f5dfb.png";